module.exports = __webpack_public_path__ + "img/pendiente.656891b1.svg";